import { Component, OnInit, Inject, Output, EventEmitter } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

export interface SectionProperties {
  sectionName: string;
  detailPage: boolean;
  editPage: boolean;
  onnew: boolean;
  onedit: boolean;
  imageSection: false,
  systemSection: true,
  column: number;
  id: string;
}

@Component({
  selector: "app-section-dialog",
  templateUrl: "./section-dialog.component.html",
  styleUrls: ["./section-dialog.component.scss"],
})
export class SectionDialogComponent implements OnInit {
  @Output() sectionPropertiesChanged: EventEmitter<SectionProperties> =
    new EventEmitter<SectionProperties>();

  sectionProperties: SectionProperties = {
    sectionName: "",
    detailPage: true,
    editPage: false,
    onnew: true,
    onedit: true,
    imageSection: false,
    systemSection: true,
    column: 2,

    id: "",
  };

  constructor(
    private dialogRef: MatDialogRef<SectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  private normalizeBoolean(value: any, defaultValue: boolean = true): boolean {
    if (value == null) {
      return defaultValue;
    }

    return value === true || value === "true" || value === 1 || value === "1";
  }

  ngOnInit() {
    console.log(this.data);

    if (this.data && this.data.sectionProperties) {
      this.sectionProperties = {
        ...this.sectionProperties,
        ...this.data.sectionProperties,
        onnew: this.normalizeBoolean(this.data.sectionProperties.onnew),
        onedit: this.normalizeBoolean(this.data.sectionProperties.onedit),
      };
    }
  }

  onSave() {
    this.dialogRef.close(this.sectionProperties);
    this.sectionPropertiesChanged.emit(this.sectionProperties);
    console.log("Result *** ", this.sectionProperties);
  }

  close() {
    this.dialogRef.close();
  }
}
